import React from "react";
import { Modal, ModalBody, modalConnect } from "@modal";
import { ceModalConvertHTMLToTextClose } from "@js/actions/studio/campaign_content_section/modal_convert_html_to_text.js";

const ModalConvertHTMLToText = modalConnect((props) => {
  return (
    <Modal
      title={t("phrases.react_content.convert_from_html")}
      onCancel={() => {
        props.dispatch(ceModalConvertHTMLToTextClose());
      }}
    >
      <ModalBody>
        {props.validation_error ? (
          <p>{props.validation_error}</p>
        ) : (
          t("phrases.react_content.converting_html")
        )}
      </ModalBody>
    </Modal>
  );
});

export default ModalConvertHTMLToText;
